<div class="container">
  <div class="row">
    <div class="col-lg-8" style="margin-bottom: 20px;">
      <div class="card card-custom gutter-b">
        <ng-container *ngIf="isLoading$ | async">
          <div class="progress progress-modal">
            <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar"
              style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
        </ng-container>
        <div class="card-header">
          <div class="card-title">
            <!-- <span [inlineSVG]="'./assets/media/svg/icons/System/Appointments.svg'" cacheSVG="true"
              class="svg-icon svg-icon-3x "></span> -->
            <h4 class="card-label" style="margin: 15px;font-weight: bold;">
              {{'APPOINTMENTS.ADD.NEWAPPOINTMENT' | translate}}
            </h4>
          </div>
        </div>
        <div class="card-body">
          <div class="mt-1">
            <form action="#" class="form form-label-right" [formGroup]="formGroup" >
              <div class="form-group row">
                <div class="col-lg-2"></div>
                <div class="col-lg-4" style="margin-bottom: 20px;">
                  <label>{{'APPOINTMENTS.ADD.SPECIALTY' | translate}}</label><label id="FieldRequired"
                    class="text-danger">*</label>
                  <select class="form-control" formControlName="SpecialtyId" (change)="OnChangeSpecialty($event)"
                    *ngIf="Specialties$ | async as Specialties ;else EmptySpecialties"
                    [class.is-invalid]="isControlInvalid('SpecialtyId')" [class.is-valid]="isControlValid('SpecialtyId')">
                    <option value="">{{'COMMON.SELECT' | translate}}</option>
                    <option value={{Specialty.departmentId}} *ngFor="let Specialty of Specialties">{{ language == 'en'?
                      Specialty.departmentName: Specialty.departmentNameArabic }}</option>
                  </select>
                  <ng-template #EmptySpecialties>
                    <select class="form-control" formControlName="SpecialtyId"
                      [class.is-invalid]="isControlInvalid('SpecialtyId')" [class.is-valid]="isControlValid('SpecialtyId')">
                      <option value="">{{'COMMON.SELECT' | translate}}</option>
                    </select>
                  </ng-template>
                  <div class="invalid-feedback ValidateText" *ngIf="controlHasError('required', 'SpecialtyId')" >
                    {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                  </div>
      
                  <!-- <label style="margin-top: 30px;">{{'APPOINTMENTS.ADD.DOCTOR' | translate}}</label><label id="FieldRequired"
                    class="text-danger">*</label>
                  <select class="form-control" formControlName="DoctorId" (change)="GetDoctorSlots()"
                    *ngIf="Doctors$ | async as Doctors ;else EmptyDoctors" [class.is-invalid]="isControlInvalid('DoctorId')"
                    [class.is-valid]="isControlValid('DoctorId')">
                    <option value="">{{'COMMON.SELECT' | translate}}</option>
                    <option value={{Doctor.employee?.empId}} *ngFor="let Doctor of Doctors">{{ language == 'en'? 'Dr. '+
                      Doctor.employee?.firstName +' ' + Doctor.employee?.middleName +' '+ Doctor.employee?.lastName
                      : 'د. ' + Doctor.employee?.rFirstName+' '+ Doctor.employee?.rMiddleName+' '+ Doctor.employee?.rLastName
                      }}</option>
                  </select>
                  <ng-template #EmptyDoctors>
                    <select class="form-control" formControlName="DoctorId">
                      <option value="">{{'COMMON.SELECT' | translate}}</option>
                    </select>
                  </ng-template>
                  <div class="invalid-feedback ValidateText" *ngIf="controlHasError('required', 'DoctorId')">
                    {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                  </div> -->
      
                </div>
                <div class="col-lg-4" style="margin-bottom: 20px;">
                  <label>{{'APPOINTMENTS.ADD.DOCTOR' | translate}}</label><label id="FieldRequired"
                    class="text-danger">*</label>
                  <select class="form-control" formControlName="DoctorId" (change)="GetDoctorSlots()"
                    *ngIf="Doctors$ | async as Doctors ;else EmptyDoctors" [class.is-invalid]="isControlInvalid('DoctorId')"
                    [class.is-valid]="isControlValid('DoctorId')">
                    <option value="">{{'COMMON.SELECT' | translate}}</option>
                    <option value={{Doctor.employee?.empId}} *ngFor="let Doctor of Doctors">{{ language == 'en'? 'Dr. '+
                      Doctor.employee?.firstName +' ' + Doctor.employee?.newLastname
                      : 'د. ' + Doctor.employee?.rFirstName+' '+ Doctor.employee?.rLastName
                      }}</option>
                    <!-- <option value={{Doctor.employee?.empId}} *ngFor="let Doctor of Doctors">{{ language == 'en'? 'Dr. '+
                      Doctor.employee?.firstName +' ' + Doctor.employee?.middleName +' '+ Doctor.employee?.newLastname
                      : 'د. ' + Doctor.employee?.rFirstName+' '+ Doctor.employee?.rMiddleName+' '+ Doctor.employee?.rLastName
                      }}</option> -->
                  </select>
                  <ng-template #EmptyDoctors>
                    <select class="form-control" formControlName="DoctorId">
                      <option value="">{{'COMMON.SELECT' | translate}}</option>
                    </select>
                  </ng-template>
                  <div class="invalid-feedback ValidateText" *ngIf="controlHasError('required', 'DoctorId')">
                    {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                  </div>
                </div>
                <!-- <div class="col-lg-1"></div> -->
                
              </div>
              <div class="form-group row">
                <div class="card ">
                  <div class="card-header ">
                    <div class="card-title">
                      <h5 class="card-label" style="margin: 15px;font-weight: bold;">
                        {{'APPOINTMENTS.ADD.CHOOSEYOUDATE' | translate}}
                      </h5>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="form-group row">
                      <div class="col-lg-6">
                        <label>{{'APPOINTMENTS.ADD.DATE' | translate}}</label><label id="FieldRequired"
                          class="text-danger">*</label>
                        <div class="input-group">
                          <input readonly (ngModelChange)="GetDoctorSlots()" class="form-control" placeholder="yyyy-mm-dd"
                            name="dp" formControlName="Date" ngbDatepicker #d="ngbDatepicker"
                            [class.is-invalid]="isControlInvalid('Date')" [class.is-valid]="isControlValid('Date')" />
                          <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()" type="button"><i
                              class="icofont-calendar"></i></button>
                          <!-- <div class="invalid-feedback ValidateText" *ngIf="controlHasError('required', 'Date')">
                            {{ 'AUTH.VALIDATION.REQUIRED_FIELD'| translate }}
                          </div>
                          <div class="invalid-feedback ValidateText" *ngIf="formGroup.controls.Date.errors && isControlTouched('Date')">
                            {{'APPOINTMENTS.ADD.VALIDATEDATE' | translate}}
                          </div> -->
                        </div>
                      </div>
                      <div class="col-lg-6 text-center">
                        <h3 *ngIf="SelectedDate">{{ SelectedDate | date :'dd/MM/yyyy' }}</h3>
                        <ng-container *ngFor="let Slot of DoctorSlots">
                          <div *ngIf="(Slot.registration_No != null && Slot.registration_No) && Slot.patientId != PatientId" class="badge bg-secondary">{{Slot.fromTime  | date:'shortTime':'UTC' }}</div>
                          <div *ngIf="Slot.registration_No == null || !Slot.registration_No" (click)="SaveAppointment(Slot)" style="cursor: pointer;"
                              class="badge bg-success">{{Slot.fromTime  | date:'shortTime' :'UTC'}}</div>
                           <div *ngIf="Slot.patientId == PatientId" class="badge bg-warning text-dark">{{Slot.fromTime  | date:'shortTime':'UTC' }}</div>
                           
                        </ng-container>
                      </div>
                       <div class="col-lg-6" *ngIf="SelectedDate" >
                        <div  class="badge bg-success Keys">{{ language == 'en'? 'Available' : 'متاح'}}</div><br>
                        <div  class="badge bg-secondary  Keys">{{ language == 'en'? 'Not Available' : 'غير متاح'}}</div><br>
                        <div  class="badge bg-warning text-dark Keys">{{ language == 'en'? 'Your Appointment' : 'موعدك'}}</div>
      
      
                        <!-- <ul>
                          <li class="Available">Available</li>
                          <li class="NotAvailable">Not Available</li>
                          <li class="Your Appointment">Your Appointment</li>
                        </ul> -->
                      </div> 
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row text-center" style="margin-top: 50px;">
                <div class="col-lg-12 text-center">
                  <!-- <button style="font-weight:bold;;margin: 0px 10px;" type="button" class="btn btn-success  ml-2"
                    (click)="save()">
                    {{ 'COMMON.SAVE' | translate }}
                  </button> -->
                  <!-- <a style="font-weight:bold" type="button" class="btn btn-danger ml-2"
                  [routerLink]="'/portal/appointments/doctors/' + SpecialtyId">
                    {{ 'COMMON.BACK' | translate }}
                  </a> -->
                </div>
              </div>
            </form>
          </div>
      
        </div>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="panel">
        <div class="panel-header">{{ language == 'en'? "About doctor": "نبذة عن الطبيب" }}</div>
        <div class="panel-content">
          <hr>
          <!-- <textarea [value]="AboutDoctor" class="form-control"></textarea> -->
          <div *ngFor="let char of AboutDoctor.split('-')">
           {{'-'}} {{ char }}<br>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="col-lg-4" style="margin: 10px 0px;">
      <div class="panel" [ngClass]="{ 'open': isOpen }">
        <div class="panel-header " (click)="togglePanel()">{{ language == 'en'? "About doctor": "نبذة عن الطبيب" }}</div>
        <div class="panel-content" *ngIf="isOpen">
          <hr>
          <p>{{ AboutDoctor }}</p>
        </div>
      </div>
    </div> -->
  </div>
</div>
